import { FC } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from 'store';
import { updateLayoutConfiguration } from 'actions/layoutConfiguration';
import apiUser from 'api/user';
import RoundButton from 'components/ui/roundButton';
import breakpoints from 'constants/breakpoints';

export const SidebarToggle: FC = () => {
  const dispatch = useDispatch();
  const isMenuExpanded = useSelector(
    (state: RootState) => state.layoutConfiguration.isMenuExpanded
  );
  const isMobile = window.innerWidth <= breakpoints.header;

  const handleClick = () => {
    dispatch(updateLayoutConfiguration({ isMenuExpanded: !isMenuExpanded }));
    updateConfig(!isMenuExpanded);
  };

  const updateConfig = async (isMenuExpanded: boolean) => {
    if (isMobile) {
      return;
    }

    try {
      await apiUser.setConfig({
        param: 'isMenuExpanded',
        value: isMenuExpanded,
      });
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <RoundButton
      icon='im-Menu'
      size={30}
      iconSize={14}
      customClass='header__icon_menu'
      status='none'
      onClick={handleClick}
    />
  );
};
